//#region src/report_type.ts
var ReportType = /* @__PURE__ */ function(ReportType) {
	ReportType["CouponRedemptionHistory"] = "coupon-redemption-history";
	ReportType["CustomerOrders"] = "customer-orders";
	ReportType["DayUpsell"] = "day-upsell";
	ReportType["EightySixingActivity"] = "eighty-sixing-activity";
	ReportType["FlashPayouts"] = "flash-payouts";
	ReportType["FutureOrders"] = "future-orders";
	ReportType["IndustryBenchmark"] = "industry-benchmark";
	ReportType["ItemUpsell"] = "item-upsell";
	ReportType["KioskUsageOverlap"] = "kiosk-usage-overlap";
	ReportType["KioskPeripherals"] = "kiosk-peripherals";
	ReportType["KOR"] = "kiosk-order-ready";
	ReportType["LoyaltyLoginAttempts"] = "loyalty-login-attempts";
	ReportType["LoyaltySignups"] = "loyalty-signups";
	ReportType["LoyaltyUsage"] = "loyalty-usage";
	ReportType["OrderConversionRate"] = "order-conversion-rate";
	ReportType["OrderInsertionRate"] = "order-insertion-rate";
	ReportType["PilotEngagement"] = "pilot-engagement";
	ReportType["PilotLaborAnalysis"] = "pilot-labor-analysis";
	ReportType["PunchhLocationOrders"] = "punchh-location-orders";
	ReportType["SalesGuests"] = "sales-guests";
	ReportType["SalesOrders"] = "sales-orders";
	ReportType["SalesSummaryChannel"] = "sales-summary-channel";
	ReportType["SalesSummaryModal"] = "sales-summary-modal";
	ReportType["SalesSummaryOrg"] = "sales-summary-org";
	ReportType["SalesSummarySite"] = "sales-summary-site";
	ReportType["SalesTransactions"] = "sales-transactions";
	ReportType["ThirdPartyOrders"] = "third-party-orders";
	ReportType["VendorPayouts"] = "vendor-payouts";
	ReportType["VitrineSessionMetrics"] = "vitrine-session-metrics";
	return ReportType;
}(ReportType || {});
//#endregion
export { ReportType };

//# sourceMappingURL=report_type.js.map